import {
  ADD_CAMPAIGN_CUSTOM_NAMES,
  DELETE_CAMPAIGN_CUSTOM_NAMES,
  GET_CAMPAIGN_CUSTOM_NAME_PROFILE,
  GET_CAMPAIGN_CUSTOM_NAMES_LIST,
  HIDE_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER,
  SET_CAMPAIGN_CUSTOM_NAME_PROFILE,
  SET_CAMPAIGN_CUSTOM_NAMES_LIST,
  SET_ERROR_CAMPAIGN_CUSTOM_NAME_PROFILE,
  SHOW_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER,
  UPDATE_CAMPAIGN_CUSTOM_NAME_PROFILE
} from "./actionTypes";

export const getCampaignCustomNamesList = data => ({
  type: GET_CAMPAIGN_CUSTOM_NAMES_LIST,
  payload: data
})

export const setCampaignCustomNamesList = payload => ({
  type: SET_CAMPAIGN_CUSTOM_NAMES_LIST,
  payload
})

export const showCampaignCustomNamesListLoader = () => ({
  type: SHOW_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER
})

export const hideCampaignCustomNamesListLoader = () => ({
  type: HIDE_CAMPAIGN_CUSTOM_NAMES_LIST_LOADER
})

export const addCampaignCustomNames = (customName = {}, data = {}) => ({
  type: ADD_CAMPAIGN_CUSTOM_NAMES,
  payload: { customName, data }
});

export const deleteCampaignCustomNames = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_CUSTOM_NAMES,
  payload: { id, data }
});

export const getCampaignCustomNameProfile = id => ({
  type: GET_CAMPAIGN_CUSTOM_NAME_PROFILE,
  payload: id
})

export const setCampaignCustomNameProfile = payload => ({
  type: SET_CAMPAIGN_CUSTOM_NAME_PROFILE,
  payload
})

export const updateCampaignCustomNameProfile = (id, customName = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_CUSTOM_NAME_PROFILE,
  payload: {id, customName, data }
})

export const setErrorCampaignCustomNameProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_CUSTOM_NAME_PROFILE,
  payload
})